import React from 'react';

const LobbyIcon = ({ className, style }) => /* @__PURE__ */ React.createElement(
  "svg",
  {
    className,
    style: { ...style, overflow: "visible" },
    width: "14",
    height: "17",
    viewBox: "0 0 14 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  },
  /* @__PURE__ */ React.createElement(
    "path",
    {
      d: "M10.3333 10.988V5.65468C10.3333 4.08334 10.3333 3.29766 9.8452 2.8095C9.357 2.32135 8.57133 2.32135 7 2.32135H4.33333C2.76199 2.32135 1.97631 2.32135 1.48815 2.8095C1 3.29766 1 4.08334 1 5.65468V10.988C1 12.5594 1 13.345 1.48815 13.8332C1.97631 14.3214 2.76199 14.3214 4.33333 14.3214H7C8.57133 14.3214 9.357 14.3214 9.8452 13.8332C10.3333 13.345 10.3333 12.5594 10.3333 10.988Z",
      stroke: "#E2E4EE"
    }
  ),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      d: "M6.33301 14.3214H10.333C11.5901 14.3214 12.2186 14.3214 12.6091 13.9308C12.9997 13.5403 12.9997 12.9118 12.9997 11.6547V6.98802C12.9997 5.73094 12.9997 5.1024 12.6091 4.71188C12.2186 4.32135 11.5901 4.32135 10.333 4.32135",
      stroke: "#E2E4EE"
    }
  ),
  /* @__PURE__ */ React.createElement("path", { d: "M7.66699 7.65472V8.98806", stroke: "#E2E4EE", strokeLinecap: "round" })
);
LobbyIcon.displayName = "Icons.LobbyIcon";

export { LobbyIcon };
//# sourceMappingURL=LobbyIcon.js.map
